var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "append-to-body": _vm.appendToBody,
        visible: _vm.innerVisible,
        title: _vm.$t("SystemMaintenance.BranchSelection"),
        width: "800px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticStyle: { height: "400px" },
        attrs: {
          "show-side-bar": false,
          "grid-options": _vm.gridOptions,
          "row-data": _vm.rowData,
          "check-sub-record": _vm.checkSubRecord,
          "deselect-sub-record": _vm.checkSubRecord,
          "check-main-record": _vm.checkMainRecord,
          "deselect-main-record": _vm.checkMainRecord
        }
      }),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticStyle: { "text-align": "left" } },
          [
            _c("line-label", {
              staticStyle: { color: "blue" },
              attrs: {
                label:
                  _vm.$t("SystemMaintenance.CurrentlySelectedProject") +
                  _vm.selectRowsLabel
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "margin-top": "5px"
            }
          },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.checkSubRecord,
                  callback: function($$v) {
                    _vm.checkSubRecord = $$v
                  },
                  expression: "checkSubRecord"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("SystemMaintenance.CheckParentCompanyWithSubsidiary")
                  )
                )
              ]
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "confirm", type: "primary" },
                    on: { click: _vm.onConfirm }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.confirm")))]
                ),
                _c(
                  "el-button",
                  { attrs: { no: "reset" }, on: { click: _vm.onReset } },
                  [_vm._v(_vm._s(_vm.$t("common.reset")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel" },
                    on: {
                      click: function($event) {
                        _vm.innerVisible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }